export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10133.000cd2e8.jpg";